// theme.js
// Central MUI v5 theme built from design tokens. Wrap the app in
// <ThemeProvider theme={theme}> (see index.js) so every MUI component and any
// component using `sx` / useTheme() reads these values.

import { createTheme } from "@mui/material/styles";
import { colors, fonts, radii, shadows, transitions, breakpoints } from "./tokens";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: breakpoints.xs,
      sm: breakpoints.sm,
      md: breakpoints.md,
      laptop: breakpoints.laptop,
      lg: breakpoints.lg,
      xl: breakpoints.xl,
    },
  },

  palette: {
    mode: "dark",
    primary: {
      main: colors.primary,
      contrastText: colors.background,
    },
    background: {
      default: colors.background,
      paper: colors.surface,
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
    },
    divider: colors.border,
  },

  typography: {
    fontFamily: fonts.primary,
  },

  shape: {
    borderRadius: radii.md,
  },

  // Expose the raw tokens on the theme so components can read brand values
  // via useTheme().tokens instead of hardcoding them.
  tokens: { colors, fonts, radii, shadows, transitions, breakpoints },

  components: {
    // Outlined inputs: neutral border by default, teal on hover/focus.
    // (ported from the old src/styles.js theme overrides)
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: colors.textMuted,
        },
        root: {
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.primary,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.primary,
          },
        },
      },
    },
  },
});

export default theme;
